<template>
  <div>
    <div v-if="getLimit('order_publish_import_button')" style="width:1000px">
      <el-form ref="form" label-width="120px">
        <el-form-item>
          <el-button size="small" @click="downTemplate()">
            1.下载模板
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-upload
            ref="uploadExcel"
            v-model="form.filePath"
            :action="uploadUrl"
            :on-success="handleSuccess"
            :on-error="handleError"
            accept=".xls"
            multiple
            :limit="1"
            :headers="headers"
            :on-exceed="handleExceed"
            :before-upload="beforeUploadFile"
            :before-remove="beforeRemove"
            :on-remove="onRemove"
            :file-list="fileList"
          >
            <el-button size="small" plain>
              2.选择文件
            </el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传1个模板文件(excel)，且不超过10M
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button @click="uploadFileView()">
            3.导入数据
          </el-button>
          <el-button
            type="primary"
            :disabled="isDisable"
            @click="sourceRelease()"
          >
            4.发布货源
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="580"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
    >
      <el-table-column
        prop="shipperProvinceStr"
        label="装货地址（省）"
        min-width="120"
      />
      <el-table-column
        prop="shipperCityStr"
        label="装货地址（市）"
        min-width="120"
      />
      <el-table-column
        prop="shipperCountyStr"
        label="装货地址（区县）"
        min-width="150"
      />
      <el-table-column
        prop="shipperDetailAddress"
        label="装货详细地址"
        min-width="150"
      />
      <el-table-column
        prop="consigneeProvinceStr"
        label="卸货地址（省）"
        min-width="120"
      />
      <el-table-column
        prop="consigneeCityStr"
        label="卸货地址（市）"
        min-width="130"
      />
      <el-table-column
        prop="consigneeCountyStr"
        label="卸货地址（区县）"
        min-width="150"
      />
      <el-table-column
        prop="consigneeDetailAddress"
        label="卸货地详细地址"
        min-width="150"
      />
      <el-table-column
        prop="shipperName"
        label="发货联系人姓名"
        min-width="100"
      />
      <el-table-column
        prop="shipperPhone"
        label="发货联系电话"
        min-width="120"
      />
      <el-table-column
        prop="consigneeName"
        label="卸货联系人姓名"
        min-width="100"
      />
      <el-table-column
        prop="consigneePhone"
        label="卸货联系电话"
        min-width="120"
      />
      <el-table-column
        prop="coalBigTypeStr"
        label="货物名称大类"
        min-width="120"
      />
      <el-table-column
        prop="coalTypeStr"
        label="货物名称小类"
        min-width="120"
      />
      <el-table-column prop="weight" label="货物数量" min-width="100" />
      <el-table-column
        prop="coalUnitStr"
        label="货物数量单位"
        min-width="120"
      />
      <el-table-column prop="coalPrice" label="货物单价" min-width="100" />
      <el-table-column prop="price" label="运费单价" min-width="100" />
      <el-table-column prop="isTrunkStr" label="运费单价单位" min-width="120" />
      <el-table-column
        prop="limitWastageAmount"
        label="合理耗损"
        min-width="100"
      />
      <el-table-column
        prop="limitWastageTypeStr"
        label="合理耗损单位"
        min-width="120"
      />
      <el-table-column prop="coalNumber" label="车数要求" min-width="100" />
      <el-table-column
        prop="lastLoadingTime"
        label="装货时间"
        min-width="200"
      />
      <el-table-column
        prop="lastUnloadingTime"
        label="卸货时间"
        min-width="200"
      />
      <!-- <el-table-column prop="billingTypeStr" label="开票方式" min-width="100" /> -->
      <el-table-column prop="isInsureStr" label="是否投保" min-width="260" />
      <el-table-column
        prop="insuranceCodeStr"
        label="购买保险"
        min-width="260"
      />
      <el-table-column prop="coalName" label="运输要求" min-width="100" />
      <el-table-column prop="isQuoteStr" label="允许报价" min-width="100" />
      <el-table-column prop="maxPrice" label="最高价" min-width="100" />
      <el-table-column
        prop="transportTypeStr"
        label="运输方式"
        min-width="100"
      />
      <el-table-column
        v-if="isTaxOpen"
        prop="industryStr1"
        label="行业（一级）"
        min-width="120"
      />
      <el-table-column
        v-if="isTaxOpen"
        prop="industryStr2"
        label="行业（二级）"
        min-width="120"
      />
      <el-table-column
        v-if="isTaxOpen"
        prop="industryStr3"
        label="行业（三级）"
        min-width="120"
      />
      <el-table-column
        v-if="isTaxOpen"
        prop="industryStr4"
        label="行业（四级）"
        min-width="120"
      />
    </el-table>
  </div>
</template>
<script>
import request from "@/utils/request";
import { getToken } from "@/utils/auth";
export default {
  data() {
    return {
      isDisable: false,
      fileList: [],
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      tableData: [],
      headers: {
        Authorization: "Bearer " + getToken(),
        deviceId: "0000000000"
      },
      form: {
        filePath: "",
        isView: "2"
      },
      isTaxOpen: false
    };
  },
  created() {
    request({
      url: `/ntocc-basic-api/industry/isOpen`,
      params: { type: this.form.type },
      method: "get"
    }).then(response => {
      this.isTaxOpen = response.data == 1 ? true : false;
    });
  },
  methods: {
    //上传文件预览
    uploadFileView() {
      if ("" == this.form.filePath) {
        return this.$message.warning("请先上传文件");
      }
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-tms-api/order/orderImportView`,
        params: { filePath: this.form.filePath },
        method: "post"
      }).then(response => {
        rLoading.close();
        this.tableData = response.data;
        this.$message({ message: response.msg, type: "success" });
        this.form.isView = 1;
      });
    },
    downTemplate() {
      request({
        url: `/ntocc-tms-api/order/downTemplate`,
        method: "get"
      }).then(response => {
        window.open(response.data);
      });
    },
    //发布货源
    sourceRelease() {
      if ("" == this.form.filePath) {
        return this.$message.warning("请先上传文件");
      }
      if (1 != this.form.isView) {
        return this.$message.warning(
          "请先导入数据，再发布货源，并且不能重复发布货源"
        );
      }
      this.isDisable = true;
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-tms-api/order/orderImport`,
        params: { filePath: this.form.filePath, isView: this.form.isView },
        method: "post"
      }).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.form.isView = 2;
        this.isDisable = false;
        rLoading.close();
      });
    },
    // 上传成功回调
    handleSuccess(res, file) {
      if (res.status == 500) {
        this.$message.error(res.msg);
      } else {
        this.$message({ message: res.msg, type: "success" });
        this.form.filePath = res.data;
      }
    },
    //上传前校验
    beforeUploadFile(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xls") {
        this.$message.error("只能上传xls的文件");
        return false;
      }
      if (size > 10) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }

      // 获取token值，实时获取
      this.headers.Authorization = "Bearer " + getToken();
      return true;
    },

    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: "错误",
        message: `文件上传失败`
      });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onRemove(file, fileList) {
      this.form.isView = 2;
      this.tableData = [];
      this.form.filePath = "";
      this.isDisable = false;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    }
  }
};
</script>
<style></style>
